import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NavBrandComponent } from '../nav-brand/nav-brand.component';
import { NavButtonComponent } from '../nav-button/nav-button.component';

export interface SideNavItem {
  icon: string;
  label: string;
  link?: string;
  externalUrl?: string;
  /** Optional count rendered as a badge on the item; hidden when absent or 0. */
  badge?: number;
  /** Translation key for the badge's hover tooltip. */
  badgeTooltip?: string;
  /** Translation key for a section banner shown above the first item of a group. */
  section?: string;
}

/** A run of consecutive items; when `section` is set they share a banner and indented group. */
interface SideNavGroup {
  section?: string;
  items: SideNavItem[];
}

@Component({
  selector: 'xemex-side-nav',
  imports: [NgTemplateOutlet, RouterModule, TranslateModule, NavBrandComponent, NavButtonComponent],
  templateUrl: './side-nav.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './side-nav.component.scss',
})
export class SideNavComponent {
  items = input<SideNavItem[]>([]);
  bottomItems = input<SideNavItem[]>([]);
  collapsed = input<boolean>(false);

  /** Collapses consecutive items sharing a `section` into a single group for rendering. */
  groups = computed<SideNavGroup[]>(() =>
    this.items().reduce<SideNavGroup[]>((acc, item) => {
      const last = acc[acc.length - 1];
      if (item.section && last?.section === item.section) {
        last.items.push(item);
      } else {
        acc.push({ section: item.section, items: [item] });
      }
      return acc;
    }, []),
  );
}
